import { ref, set } from 'firebase/database';
import { doc, setDoc } from 'firebase/firestore';

import { NewNotebookSheetType } from 'shared/types/notebookTypes';

import { database, firestore } from '../Common/Firebase';
import { throwErrorRollbar } from '../index';

export const createNewSheetInNotebook = async (
  nextItem: NewNotebookSheetType,
  userMail: string,
  userSubject: string,
  id: string,
) => {
  const userRef = doc(firestore, 'notebook-content/', userMail);

  await setDoc(
    userRef,
    {
      [userSubject]: {
        [id]: {
          firstContent: '',
          secondContent: '',
        },
      },
    },
    { merge: true },
  )
    .then(() => {})
    .catch(error => {
      console.error('Error adding object ttt to document testUser:', error);
      error.name = 'Error adding object ttt to document testUser:';
      throwErrorRollbar(error);
    });

  await set(ref(database, `Notebooks/${userMail}/${userSubject}/${id}`), nextItem);
};
